import { CrudFormItem } from '.';

export interface CrudFormLabelFunctionItem extends CrudFormItem {
  functionToDisplay: Function;
}
